import { ParseXml } from '../../api/converters/parseXml';
import { MessageName } from '../../controllers/gameCommunication/types';
import type { SocketCommunicationStrategy } from '../../services/webSocket/types';

import {
  type BaseGameCommunicationMessageType,
  type GameCommunicationMessageType,
  type UnknownMessage,
  MessageNameValue,
} from './types';

export class GameCommunicationStrategy implements SocketCommunicationStrategy<GameCommunicationMessageType> {
  constructor(private gameChannel: string | null = null) {}

  setGameChannel(gameChannel: string): void {
    this.gameChannel = gameChannel;
  }

  private readMessage(message: MessageEvent): Record<string, unknown> {
    if (message.data.startsWith('<')) {
      return ParseXml.parseString(message.data) as Record<string, unknown>;
    } else {
      return JSON.parse(message.data) as Record<string, unknown>;
    }
  }

  parseMessage(message: MessageEvent): GameCommunicationMessageType {
    const parsedMessage = this.readMessage(message);
    const messageName = Object.keys(parsedMessage)[0] as MessageNameValue;

    switch (messageName) {
      case MessageName.Session:
        return {
          ...(parsedMessage as BaseGameCommunicationMessageType),
          messageName: messageName,
        };
      default:
        return {
          ...(parsedMessage[messageName] as BaseGameCommunicationMessageType),
          messageName,
        } as UnknownMessage;
    }
  }

  recognizePongMessage: (message: GameCommunicationMessageType) => boolean = (message) => {
    return message.messageName === MessageName.Pong;
  };

  assemblePingMessage: () => string | ArrayBufferLike | Blob | ArrayBufferView = () => {
    if (!this.gameChannel) throw new Error('Game channel is not set');
    return `<ping channel="${this.gameChannel}" time="${Date.now()}"/>`;
  };
}

export const gameCommunicationStrategy = new GameCommunicationStrategy(null);
